import { useState } from "react";
import BasicModal from "components/Modals/BasicModal";
import StdButton from "components/Buttons/StdButton";
import { CheckCircleIcon } from "components/Icons";
import { FormattedMessage as FM } from "react-intl";

const TagSelector = ({ open, onClose, tags, onConfirm, onSkip }) => {
  const [selectedIndices, setSelectedIndices] = useState([]);

  const toggleTag = (index, e) => {
    e.stopPropagation();
    setSelectedIndices((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index],
    );
  };

  const handleConfirm = (e) => {
    e.stopPropagation();
    const selectedTagsNames = selectedIndices
      .map((i) => tags[i]?.name)
      .filter(Boolean)
      .join(", ");
    onConfirm(selectedTagsNames);
    onClose();
  };

  const handleSkip = (e) => {
    e.stopPropagation();
    onSkip();
    onClose();
  };

  return (
    <BasicModal
      open={open}
      onClose={onClose}
      title="sale.lines.add_tags"
      width="w-200!"
    >
      {tags && tags.length > 0 ? (
        <>
          <div className="grid grid-cols-3 gap-2 p-5">
            {tags.map((tag, index) => (
              <div
                key={index}
                className={`w-50 px-5 py-3 hover:scale-100 border cursor-pointer duration-100 transform rounded-lg transition-all flex items-center space-x-4 justify-between ${
                  selectedIndices.includes(index)
                    ? "bg-green-400 border-green-600"
                    : "bg-green-100 border-green-200"
                }`}
                onClick={(e) => toggleTag(index, e)}
              >
                <span>{tag.name}</span>
                {selectedIndices.includes(index) && (
                  <CheckCircleIcon
                    width={22}
                    className="fill-green-700 justify-self-center"
                  />
                )}
              </div>
            ))}
          </div>
          <div className="flex justify-center gap-3 px-4 pb-4">
            {selectedIndices.length > 0 && (
              <StdButton
                color="blue"
                onClick={handleConfirm}
                content={"sale.lines.add_tags"}
              />
            )}
            <StdButton
              color="black"
              onClick={handleSkip}
              content={"sale.lines.skip_tags"}
            />
          </div>
        </>
      ) : (
        <p className="text-center text-gray-400 py-5">
          <FM id="sale.lines.no_tags" />
        </p>
      )}
    </BasicModal>
  );
};

export default TagSelector;
